// Super Wear Products Data - Updated to match new categories
export const products = [
  // Women's Ready to Wear Collection
  {
    id: 1,
    productId: "001030",
    datePosted: "010124",
    name: "Embroidered Lawn Suit - Mint Breeze",
    createdBy: 257, // Team Member ID
    category: "ready-to-wear",
    mainCategory: "women",
    subcategory: "embroidered",
    price: 4990,
    image: "https://picsum.photos/500/750?random=1",
    images: [
      "https://picsum.photos/500/750?random=1",
      "https://picsum.photos/500/750?random=2",
      "https://picsum.photos/500/750?random=3"
    ],
    description: "Elegant mint green lawn suit with delicate floral embroidery and modern cut.",
    isNew: true,
    sizes: ["XS", "S", "M", "L", "XL"],
    colors: ["Mint Green", "Powder Blue", "Light Pink"],
    fabric: "Premium Lawn",
    material: "100% Cotton",
    care: "Machine wash cold, gentle cycle",
    stock: {
      "Mint Green": {
        "XS": 5,
        "S": 8,
        "M": 12,
        "L": 6,
        "XL": 3
      },
      "Powder Blue": {
        "XS": 3,
        "S": 10,
        "M": 15,
        "L": 8,
        "XL": 4
      },
      "Light Pink": {
        "XS": 7,
        "S": 12,
        "M": 18,
        "L": 9,
        "XL": 5
      }
    },
    url: "010124w001030"
  },
  {
    id: 2,
    productId: "001031",
    datePosted: "010124",
    name: "Digital Print Cambric Suit",
    createdBy: 289, // Team Member ID
    category: "ready-to-wear",
    mainCategory: "women",
    subcategory: "printed",
    price: 3990,
    image: "https://picsum.photos/500/750?random=4",
    images: [
      "https://picsum.photos/500/750?random=4",
      "https://picsum.photos/500/750?random=5"
    ],
    description: "Contemporary digital printed cambric suit in vibrant summer hues.",
    isNew: true,
    sizes: ["XS", "S", "M", "L", "XL"],
    colors: ["Blue", "Orange", "Yellow"],
    fabric: "Cambric",
    material: "100% Cotton",
    care: "Machine wash cold",
    stock: {
      "Blue": {
        "XS": 10,
        "S": 15,
        "M": 20,
        "L": 12,
        "XL": 8
      },
      "Orange": {
        "XS": 10,
        "S": 15,
        "M": 20,
        "L": 12,
        "XL": 8
      },
      "Yellow": {
        "XS": 10,
        "S": 15,
        "M": 20,
        "L": 12,
        "XL": 8
      }
    },
    url: "010124w001031"
  },
  {
    id: 3,
    productId: "001032",
    datePosted: "010124",
    name: "Luxury Embroidered Chiffon",
    createdBy: 306, // Team Member ID
    category: "ready-to-wear",
    mainCategory: "women",
    subcategory: "formal",
    price: 8990,
    originalPrice: 9990,
    image: "https://picsum.photos/500/750?random=6",
    images: [
      "https://picsum.photos/500/750?random=6",
      "https://picsum.photos/500/750?random=7",
      "https://picsum.photos/500/750?random=8"
    ],
    description: "Luxurious chiffon suit with intricate embroidery and pearl details.",
    isNew: true,
    isOnSale: true,
    sizes: ["S", "M", "L", "XL"],
    colors: ["Ivory", "Champagne", "Rose Gold"],
    fabric: "Pure Chiffon",
    material: "Silk Blend",
    care: "Dry clean only",
    stock: {
      "Ivory": {
        "S": 8,
        "M": 12,
        "L": 10,
        "XL": 6
      },
      "Champagne": {
        "S": 10,
        "M": 15,
        "L": 12,
        "XL": 8
      },
      "Rose Gold": {
        "S": 6,
        "M": 10,
        "L": 8,
        "XL": 5
      }
    },
    url: "010124w001032"
  },
  // Unstitched Collection
  {
    id: 4,
    productId: "001033",
    datePosted: "010124",
    name: "3 Piece Printed Lawn Suit",
    createdBy: 257, // Team Member ID
    category: "unstitched",
    mainCategory: "women",
    subcategory: "lawn",
    price: 4490,
    image: "https://picsum.photos/500/750?random=9",
    images: [
      "https://picsum.photos/500/750?random=9",
      "https://picsum.photos/500/750?random=10"
    ],
    description: "3-piece unstitched lawn suit with digital prints and embroidered neckline.",
    isNew: true,
    pieces: 3,
    includes: ["Shirt Fabric", "Trouser Fabric", "Printed Dupatta"],
    fabric: "Lawn",
    colors: ["Turquoise", "Pink", "Yellow"],
    material: "100% Cotton",
    care: "Machine wash gentle cycle",
    stock: {
      "Turquoise": 15,
      "Pink": 8,
      "Yellow": 12
    },
    url: "010124w001033"
  },
  {
    id: 5,
    productId: "001034",
    datePosted: "010124",
    name: "Premium Jacquard Collection",
    createdBy: 289, // Team Member ID
    category: "unstitched",
    mainCategory: "women",
    subcategory: "jacquard",
    price: 7990,
    image: "https://picsum.photos/500/750?random=11",
    images: [
      "https://picsum.photos/500/750?random=11",
      "https://picsum.photos/500/750?random=12"
    ],
    description: "Premium jacquard fabric with intricate woven patterns and embroidery.",
    isNew: true,
    pieces: 3,
    includes: ["Jacquard Shirt", "Cotton Trouser", "Silk Dupatta"],
    fabric: "Jacquard",
    colors: ["Deep Blue", "Gold", "Maroon"],
    material: "Cotton Blend",
    care: "Dry clean recommended",
    stock: {
      "Deep Blue": 15,
      "Gold": 12,
      "Maroon": 18
    },
    url: "010124w001034"
  },
  // Men's Collection
  {
    id: 6,
    productId: "001035",
    datePosted: "010124",
    name: "Men's Cotton Kurta",
    createdBy: 306, // Team Member ID
    category: "man",
    mainCategory: "men",
    subcategory: "kurta",
    price: 2990,
    image: "https://picsum.photos/500/750?random=13",
    images: [
      "https://picsum.photos/500/750?random=13",
      "https://picsum.photos/500/750?random=14"
    ],
    description: "Classic cotton kurta with minimal embroidery, perfect for casual wear.",
    isNew: true,
    sizes: ["S", "M", "L", "XL", "XXL"],
    colors: ["White", "Black", "Navy"],
    fabric: "Cotton",
    material: "100% Cotton",
    care: "Machine wash cold",
    stock: {
      "White": {
        "S": 12,
        "M": 18,
        "L": 15,
        "XL": 10,
        "XXL": 8
      },
      "Black": {
        "S": 10,
        "M": 16,
        "L": 14,
        "XL": 12,
        "XXL": 6
      },
      "Navy": {
        "S": 8,
        "M": 14,
        "L": 12,
        "XL": 9,
        "XXL": 5
      }
    },
    url: "010124m001035"
  },
  {
    id: 7,
    productId: "001036",
    datePosted: "01724",
    name: "Men's Formal Waistcoat",
    category: "man",
    mainCategory: "men",
    subcategory: "waistcoat",
    price: 5990,
    image: "https://picsum.photos/500/750?random=15",
    images: [
      "https://picsum.photos/500/750?random=15",
      "https://picsum.photos/500/750?random=16"
    ],
    description: "Elegant waistcoat with detailed embroidery for formal occasions.",
    isNew: true,
    sizes: ["S", "M", "L", "XL"],
    colors: ["Black", "Navy", "Maroon"],
    fabric: "Jacquard",
    material: "Polyester Blend",
    care: "Dry clean only",
    stock: {
      "Black": {
        "S": 8,
        "M": 12,
        "L": 10,
        "XL": 6
      },
      "Navy": {
        "S": 6,
        "M": 10,
        "L": 8,
        "XL": 5
      },
      "Maroon": {
        "S": 7,
        "M": 11,
        "L": 9,
        "XL": 4
      }
    },
    url: "010124m001036"
  },
  // Western Collection
  {
    id: 8,
    productId: "001037",
    datePosted: "01724",
    name: "Floral Maxi Dress",
    category: "west",
    mainCategory: "women",
    subcategory: "dresses",
    price: 6990,
    image: "https://picsum.photos/500/750?random=17",
    images: [
      "https://picsum.photos/500/750?random=17",
      "https://picsum.photos/500/750?random=18"
    ],
    description: "Elegant floral maxi dress with ruffle details and belt.",
    isNew: true,
    sizes: ["XS", "S", "M", "L"],
    colors: ["Floral Print", "Blue Print"],
    fabric: "Chiffon",
    material: "Polyester",
    care: "Hand wash cold",
    stock: {
      "Floral Print": {
        "XS": 8,
        "S": 12,
        "M": 15,
        "L": 10
      },
      "Blue Print": {
        "XS": 6,
        "S": 10,
        "M": 13,
        "L": 8
      }
    },
    url: "010124w001037"
  },
  {
    id: 9,
    productId: "001038",
    datePosted: "01724",
    name: "Western Top with Jeans",
    category: "west",
    mainCategory: "women",
    subcategory: "tops",
    price: 3990,
    image: "https://picsum.photos/500/750?random=19",
    images: [
      "https://picsum.photos/500/750?random=19",
      "https://picsum.photos/500/750?random=20"
    ],
    description: "Stylish western top perfect with jeans or skirts.",
    isNew: true,
    sizes: ["XS", "S", "M", "L"],
    colors: ["White", "Black", "Red"],
    fabric: "Cotton Blend",
    material: "Cotton",
    care: "Machine wash cold",
    stock: {
      "White": {
        "XS": 10,
        "S": 15,
        "M": 18,
        "L": 12
      },
      "Black": {
        "XS": 8,
        "S": 13,
        "M": 16,
        "L": 10
      },
      "Red": {
        "XS": 6,
        "S": 11,
        "M": 14,
        "L": 9
      }
    },
    url: "010124w001038"
  },
  // Kids Collection
  {
    id: 10,
    productId: "001039",
    datePosted: "01724",
    name: "Kids Party Wear Suit",
    category: "kids",
    mainCategory: "kids",
    subcategory: "party-wear",
    price: 2990,
    image: "https://picsum.photos/500/750?random=21",
    images: [
      "https://picsum.photos/500/750?random=21",
      "https://picsum.photos/500/750?random=22"
    ],
    description: "Adorable party wear suit for special occasions.",
    isNew: true,
    sizes: ["2-3Y", "4-5Y", "6-7Y", "8-9Y"],
    colors: ["Pink", "Blue", "Purple"],
    fabric: "Silk",
    material: "Silk Blend",
    care: "Dry clean only",
    stock: {
      "Pink": {
        "2-3Y": 8,
        "4-5Y": 12,
        "6-7Y": 10,
        "8-9Y": 6
      },
      "Blue": {
        "2-3Y": 6,
        "4-5Y": 10,
        "6-7Y": 8,
        "8-9Y": 5
      },
      "Purple": {
        "2-3Y": 7,
        "4-5Y": 11,
        "6-7Y": 9,
        "8-9Y": 4
      }
    },
    url: "010124k001039"
  },
  // Accessories
  {
    id: 11,
    productId: "001040",
    datePosted: "01724",
    name: "Embroidered Handbag",
    category: "accessories",
    mainCategory: "all",
    subcategory: "bags",
    price: 1990,
    image: "https://picsum.photos/500/750?random=23",
    images: [
      "https://picsum.photos/500/750?random=23",
      "https://picsum.photos/500/750?random=24"
    ],
    description: "Beautiful embroidered handbag with traditional motifs.",
    isNew: true,
    colors: ["Gold", "Silver", "Rose Gold"],
    material: "Fabric with Embellishments",
    care: "Spot clean only",
    stock: {
      "Gold": 15,
      "Silver": 12,
      "Rose Gold": 18
    },
    url: "010124a001040"
  },
  // Fragrances
  {
    id: 12,
    productId: "001041",
    datePosted: "01724",
    name: "Premium Attar Collection",
    category: "fragrances",
    mainCategory: "all",
    subcategory: "attars",
    price: 2990,
    image: "https://picsum.photos/500/750?random=25",
    images: [
      "https://picsum.photos/500/750?random=25",
      "https://picsum.photos/500/750?random=26"
    ],
    description: "Exclusive collection of traditional attars.",
    isNew: true,
    colors: ["Amber", "Rose", "Sandalwood"],
    material: "Natural Oils",
    care: "Store in cool, dry place",
    stock: {
      "Amber": 20,
      "Rose": 25,
      "Sandalwood": 18
    },
    url: "010124f001041"
  },
  {
    id: 12.1,
    productId: "001041.1",
    datePosted: "01724",
    name: "Luxury Perfume Collection",
    category: "fragrances",
    mainCategory: "all",
    subcategory: "perfumes",
    price: 5990,
    image: "https://picsum.photos/500/750?random=25.1",
    images: [
      "https://picsum.photos/500/750?random=25.1",
      "https://picsum.photos/500/750?random=25.2"
    ],
    description: "Premium luxury perfumes for special occasions.",
    isNew: true,
    colors: ["Vanilla", "Lavender", "Jasmine"],
    material: "Premium Fragrance Oils",
    care: "Store in cool, dry place away from sunlight",
    stock: {
      "Vanilla": 15,
      "Lavender": 12,
      "Jasmine": 18
    },
    url: "010124f001041.1"
  },
  {
    id: 12.2,
    productId: "001041.2",
    datePosted: "01724",
    name: "Men's Cologne Set",
    category: "fragrances",
    mainCategory: "all",
    subcategory: "men",
    price: 3990,
    image: "https://picsum.photos/500/750?random=25.3",
    images: [
      "https://picsum.photos/500/750?random=25.3",
      "https://picsum.photos/500/750?random=25.4"
    ],
    description: "Masculine cologne collection for men.",
    isNew: true,
    colors: ["Woody", "Citrus", "Spicy"],
    material: "Premium Cologne",
    care: "Store in cool, dry place",
    stock: {
      "Woody": 14,
      "Citrus": 16,
      "Spicy": 12
    },
    url: "010124f001041.2"
  },
  {
    id: 12.3,
    productId: "001041.3",
    datePosted: "01724",
    name: "Women's Body Spray Collection",
    category: "fragrances",
    mainCategory: "all",
    subcategory: "women",
    price: 1990,
    image: "https://picsum.photos/500/750?random=25.5",
    images: [
      "https://picsum.photos/500/750?random=25.5",
      "https://picsum.photos/500/750?random=25.6"
    ],
    description: "Refreshing body sprays for daily use.",
    isNew: true,
    colors: ["Floral", "Fruity", "Fresh"],
    material: "Body Spray",
    care: "Store in cool, dry place",
    stock: {
      "Floral": 20,
      "Fruity": 18,
      "Fresh": 22
    },
    url: "010124f001041.3"
  },
  // New In Collection
  {
    id: 13,
    productId: "001042",
    datePosted: "01724",
    name: "Latest Summer Collection Suit",
    category: "new-in",
    mainCategory: "all",
    subcategory: "latest-arrivals",
    price: 5990,
    image: "https://picsum.photos/500/750?random=27",
    images: [
      "https://picsum.photos/500/750?random=27",
      "https://picsum.photos/500/750?random=28"
    ],
    description: "Fresh summer collection with modern designs.",
    isNew: true,
    sizes: ["XS", "S", "M", "L", "XL"],
    colors: ["Coral", "Mint", "Lavender"],
    fabric: "Lawn",
    material: "100% Cotton",
    care: "Machine wash cold",
    stock: {
      "Coral": {
        "XS": 8,
        "S": 12,
        "M": 15,
        "L": 10,
        "XL": 6
      },
      "Mint": {
        "XS": 10,
        "S": 14,
        "M": 18,
        "L": 12,
        "XL": 8
      },
      "Lavender": {
        "XS": 6,
        "S": 10,
        "M": 13,
        "L": 8,
        "XL": 5
      }
    },
    url: "010124s001042"
  },
  // Modest Wear
  {
    id: 14,
    productId: "001043",
    datePosted: "01724",
    name: "Elegant Abaya Collection",
    category: "modest-wear",
    mainCategory: "women",
    subcategory: "abayas",
    price: 8990,
    image: "https://picsum.photos/500/750?random=29",
    images: [
      "https://picsum.photos/500/750?random=29",
      "https://picsum.photos/500/750?random=30"
    ],
    description: "Elegant abaya collection with modern styling.",
    isNew: true,
    sizes: ["S", "M", "L", "XL"],
    colors: ["Black", "Navy", "Charcoal"],
    fabric: "Crepe",
    material: "Polyester Blend",
    care: "Dry clean only",
    stock: {
      "Black": {
        "S": 10,
        "M": 15,
        "L": 12,
        "XL": 8
      },
      "Navy": {
        "S": 8,
        "M": 12,
        "L": 10,
        "XL": 6
      },
      "Charcoal": {
        "S": 6,
        "M": 10,
        "L": 8,
        "XL": 5
      }
    },
    url: "010124w001043"
  },
  // Special Collection
  {
    id: 15,
    productId: "001044",
    datePosted: "01724",
    name: "Bridal Collection Suit",
    category: "special",
    mainCategory: "all",
    subcategory: "bridal-collection",
    price: 15990,
    image: "https://picsum.photos/500/750?random=31",
    images: [
      "https://picsum.photos/500/750?random=31",
      "https://picsum.photos/500/750?random=32"
    ],
    description: "Exclusive bridal collection with heavy embroidery.",
    isNew: true,
    sizes: ["S", "M", "L", "XL"],
    colors: ["Red", "Gold", "Maroon"],
    fabric: "Silk",
    material: "Pure Silk",
    care: "Dry clean only",
    stock: {
      "Red": {
        "S": 5,
        "M": 8,
        "L": 6,
        "XL": 4
      },
      "Gold": {
        "S": 4,
        "M": 6,
        "L": 5,
        "XL": 3
      },
      "Maroon": {
        "S": 6,
        "M": 9,
        "L": 7,
        "XL": 5
      }
    },
    url: "010124s001044"
  },
  {
    id: 16,
    productId: "001045",
    datePosted: "01724",
    name: "Embroidered Formal Kurti",
    category: "ready-to-wear",
    mainCategory: "women",
    subcategory: "formal",
    price: 6990,
    image: "https://picsum.photos/500/750?random=33",
    images: [
      "https://picsum.photos/500/750?random=33",
      "https://picsum.photos/500/750?random=34"
    ],
    description: "Elegant formal kurti with intricate embroidery work.",
    isNew: true,
    sizes: ["XS", "S", "M", "L", "XL"],
    colors: ["Navy", "Maroon", "Black"],
    fabric: "Premium Cotton",
    material: "Cotton Blend",
    care: "Dry clean recommended",
    stock: {
      "Navy": {
        "XS": 8,
        "S": 12,
        "M": 15,
        "L": 10,
        "XL": 6
      },
      "Maroon": {
        "XS": 6,
        "S": 10,
        "M": 13,
        "L": 8,
        "XL": 5
      },
      "Black": {
        "XS": 10,
        "S": 14,
        "M": 18,
        "L": 12,
        "XL": 8
      }
    },
    url: "010124w001045"
  },
  {
    id: 17,
    productId: "001046",
    datePosted: "01724",
    name: "Casual Summer Pants",
    category: "west",
    mainCategory: "women",
    subcategory: "bottoms",
    price: 3990,
    image: "https://picsum.photos/500/750?random=35",
    images: [
      "https://picsum.photos/500/750?random=35",
      "https://picsum.photos/500/750?random=36"
    ],
    description: "Comfortable summer pants with modern cut and style.",
    isNew: true,
    sizes: ["XS", "S", "M", "L"],
    colors: ["Beige", "White", "Black"],
    fabric: "Cotton Blend",
    material: "Cotton Polyester",
    care: "Machine wash cold",
    stock: {
      "Beige": {
        "XS": 12,
        "S": 16,
        "M": 20,
        "L": 14
      },
      "White": {
        "XS": 10,
        "S": 14,
        "M": 18,
        "L": 12
      },
      "Black": {
        "XS": 8,
        "S": 12,
        "M": 16,
        "L": 10
      }
    },
    url: "010124w001046"
  },
  {
    id: 18,
    productId: "001047",
    datePosted: "01724",
    name: "Printed Summer Shirt",
    category: "west",
    mainCategory: "women",
    subcategory: "tops",
    price: 2990,
    image: "https://picsum.photos/500/750?random=37",
    images: [
      "https://picsum.photos/500/750?random=37",
      "https://picsum.photos/500/750?random=38"
    ],
    description: "Trendy printed summer shirt with comfortable fit.",
    isNew: true,
    sizes: ["XS", "S", "M", "L", "XL"],
    colors: ["Floral Print", "Blue Print"],
    fabric: "Cotton",
    material: "100% Cotton",
    care: "Machine wash cold",
    stock: {
      "Floral Print": {
        "XS": 10,
        "S": 15,
        "M": 18,
        "L": 12,
        "XL": 8
      },
      "Blue Print": {
        "XS": 8,
        "S": 13,
        "M": 16,
        "L": 10,
        "XL": 6
      }
    },
    url: "010124w001047"
  },
  {
    id: 19,
    productId: "001048",
    datePosted: "01724",
    name: "Men's Formal Shirt",
    category: "man",
    mainCategory: "men",
    subcategory: "formal-shirts",
    price: 4490,
    image: "https://picsum.photos/500/750?random=39",
    images: [
      "https://picsum.photos/500/750?random=39",
      "https://picsum.photos/500/750?random=40"
    ],
    description: "Classic formal shirt for men with modern fit.",
    isNew: true,
    sizes: ["S", "M", "L", "XL", "XXL"],
    colors: ["White", "Light Blue", "Pink"],
    fabric: "Cotton",
    material: "100% Cotton",
    care: "Machine wash cold",
    stock: {
      "White": {
        "S": 15,
        "M": 20,
        "L": 18,
        "XL": 12,
        "XXL": 8
      },
      "Light Blue": {
        "S": 12,
        "M": 16,
        "L": 14,
        "XL": 10,
        "XXL": 6
      },
      "Pink": {
        "S": 8,
        "M": 12,
        "L": 10,
        "XL": 8,
        "XXL": 5
      }
    },
    url: "010124m001048"
  },
  {
    id: 20,
    productId: "001049",
    datePosted: "01724",
    name: "Men's Casual T-Shirt",
    category: "man",
    mainCategory: "men",
    subcategory: "t-shirts",
    price: 1990,
    image: "https://picsum.photos/500/750?random=41",
    images: [
      "https://picsum.photos/500/750?random=41",
      "https://picsum.photos/500/750?random=42"
    ],
    description: "Comfortable casual t-shirt for everyday wear.",
    isNew: true,
    sizes: ["S", "M", "L", "XL", "XXL"],
    colors: ["Navy", "Grey", "Black"],
    fabric: "Cotton Jersey",
    material: "100% Cotton",
    care: "Machine wash cold",
    stock: {
      "Navy": {
        "S": 18,
        "M": 22,
        "L": 20,
        "XL": 15,
        "XXL": 10
      },
      "Grey": {
        "S": 16,
        "M": 20,
        "L": 18,
        "XL": 12,
        "XXL": 8
      },
      "Black": {
        "S": 14,
        "M": 18,
        "L": 16,
        "XL": 11,
        "XXL": 7
      }
    },
    url: "010124m001049"
  },
  {
    id: 21,
    productId: "001050",
    datePosted: "01724",
    name: "Luxury Velvet Shawl",
    category: "accessories",
    mainCategory: "women",
    subcategory: "shawls",
    price: 4990,
    image: "https://picsum.photos/500/750?random=43",
    images: [
      "https://picsum.photos/500/750?random=43",
      "https://picsum.photos/500/750?random=44"
    ],
    description: "Luxurious velvet shawl with intricate embroidery.",
    isNew: true,
    colors: ["Black", "Maroon", "Navy"],
    material: "Velvet",
    care: "Dry clean only",
    stock: {
      "Black": 15,
      "Maroon": 12,
      "Navy": 10
    },
    url: "010124w001050"
  },
  {
    id: 22,
    productId: "001051",
    datePosted: "01724",
    name: "Crystal Drop Earrings",
    category: "accessories",
    mainCategory: "women",
    subcategory: "jewelry",
    price: 2990,
    image: "https://picsum.photos/500/500?random=45",
    images: [
      "https://picsum.photos/500/500?random=45",
      "https://picsum.photos/500/500?random=46"
    ],
    description: "Elegant crystal drop earrings for special occasions.",
    isNew: true,
    colors: ["Silver", "Gold"],
    material: "Crystal, Metal",
    care: "Store in jewelry box",
    stock: {
      "Silver": 20,
      "Gold": 18
    },
    url: "010124w001051"
  },
  {
    id: 23,
    productId: "001052",
    datePosted: "01724",
    name: "Leather Tote Bag",
    category: "accessories",
    mainCategory: "women",
    subcategory: "bags",
    price: 7990,
    image: "https://picsum.photos/500/500?random=47",
    images: [
      "https://picsum.photos/500/500?random=47",
      "https://picsum.photos/500/500?random=48"
    ],
    description: "Premium leather tote bag with spacious compartments.",
    isNew: true,
    colors: ["Brown", "Black", "Tan"],
    material: "Genuine Leather",
    care: "Clean with leather cleaner",
    stock: {
      "Brown": 12,
      "Black": 15,
      "Tan": 10
    },
    url: "010124w001052"
  },
  {
    id: 24,
    productId: "001053",
    datePosted: "01724",
    name: "Embellished Evening Clutch",
    category: "accessories",
    mainCategory: "women",
    subcategory: "bags",
    price: 5990,
    image: "https://picsum.photos/500/500?random=49",
    images: [
      "https://picsum.photos/500/500?random=49",
      "https://picsum.photos/500/500?random=50"
    ],
    description: "Elegant evening clutch with crystal embellishments.",
    isNew: true,
    colors: ["Gold", "Silver", "Black"],
    material: "Metal & Crystal",
    care: "Store in dust bag",
    stock: {
      "Gold": 8,
      "Silver": 10,
      "Black": 12
    },
    url: "010124w001053"
  },
  {
    id: 25,
    productId: "001054",
    datePosted: "01724",
    name: "Designer Sunglasses",
    category: "accessories",
    mainCategory: "women",
    subcategory: "eyewear",
    price: 4990,
    image: "https://picsum.photos/500/500?random=51",
    images: [
      "https://picsum.photos/500/500?random=51",
      "https://picsum.photos/500/500?random=52"
    ],
    description: "Trendy designer sunglasses with UV protection.",
    isNew: true,
    colors: ["Black", "Brown", "Gold"],
    material: "Metal & Acetate",
    care: "Clean with microfiber cloth",
    stock: {
      "Black": 14,
      "Brown": 12,
      "Gold": 8
    },
    url: "010124w001054"
  },
  {
    id: 26,
    productId: "001055",
    datePosted: "01724",
    name: "Embroidered Chiffon Dress",
    category: "ready-to-wear",
    mainCategory: "women",
    subcategory: "formal",
    price: 8990,
    image: "https://picsum.photos/500/750?random=53",
    images: [
      "https://picsum.photos/500/750?random=53",
      "https://picsum.photos/500/750?random=54"
    ],
    description: "Elegant chiffon dress with intricate embroidery work.",
    isNew: true,
    sizes: ["XS", "S", "M", "L"],
    colors: ["Navy", "Maroon", "Black"],
    fabric: "Chiffon",
    material: "Pure Chiffon",
    care: "Dry clean only",
    stock: {
      "Navy": {
        "XS": 6,
        "S": 10,
        "M": 12,
        "L": 8
      },
      "Maroon": {
        "XS": 5,
        "S": 8,
        "M": 10,
        "L": 7
      },
      "Black": {
        "XS": 8,
        "S": 12,
        "M": 15,
        "L": 10
      }
    },
    url: "010124w001055"
  },
  {
    id: 27,
    productId: "001056",
    datePosted: "01724",
    name: "Printed Lawn Suit",
    category: "ready-to-wear",
    mainCategory: "women",
    subcategory: "casual",
    price: 3990,
    image: "https://picsum.photos/500/750?random=55",
    images: [
      "https://picsum.photos/500/750?random=55",
      "https://picsum.photos/500/750?random=56"
    ],
    description: "Casual printed lawn suit for everyday wear.",
    isNew: true,
    sizes: ["XS", "S", "M", "L", "XL"],
    colors: ["Blue", "Pink", "Yellow"],
    fabric: "Lawn",
    material: "100% Cotton",
    care: "Machine wash cold",
    stock: {
      "Blue": {
        "XS": 12,
        "S": 16,
        "M": 20,
        "L": 14,
        "XL": 10
      },
      "Pink": {
        "XS": 10,
        "S": 14,
        "M": 18,
        "L": 12,
        "XL": 8
      },
      "Yellow": {
        "XS": 8,
        "S": 12,
        "M": 16,
        "L": 10,
        "XL": 6
      }
    },
    url: "010124w001056"
  },
  {
    id: 28,
    productId: "001057",
    datePosted: "01724",
    name: "Men's Denim Jacket",
    category: "man",
    mainCategory: "men",
    subcategory: "outerwear",
    price: 6990,
    image: "https://picsum.photos/500/750?random=57",
    images: [
      "https://picsum.photos/500/750?random=57",
      "https://picsum.photos/500/750?random=58"
    ],
    description: "Classic denim jacket for men with modern fit.",
    isNew: true,
    sizes: ["S", "M", "L", "XL"],
    colors: ["Blue", "Black"],
    fabric: "Denim",
    material: "100% Cotton",
    care: "Machine wash cold",
    stock: {
      "Blue": {
        "S": 12,
        "M": 16,
        "L": 14,
        "XL": 10
      },
      "Black": {
        "S": 10,
        "M": 14,
        "L": 12,
        "XL": 8
      }
    },
    url: "010124m001057"
  },
  {
    id: 29,
    productId: "001058",
    datePosted: "01724",
    name: "Men's Casual Pants",
    category: "man",
    mainCategory: "men",
    subcategory: "pants",
    price: 4490,
    image: "https://picsum.photos/500/750?random=59",
    images: [
      "https://picsum.photos/500/750?random=59",
      "https://picsum.photos/500/750?random=60"
    ],
    description: "Comfortable casual pants for men.",
    isNew: true,
    sizes: ["30", "32", "34", "36", "38"],
    colors: ["Khaki", "Navy", "Grey"],
    fabric: "Cotton",
    material: "98% Cotton, 2% Elastane",
    care: "Machine wash cold",
    stock: {
      "Khaki": {
        "30": 8,
        "32": 12,
        "34": 16,
        "36": 14,
        "38": 10
      },
      "Navy": {
        "30": 6,
        "32": 10,
        "34": 14,
        "36": 12,
        "38": 8
      },
      "Grey": {
        "30": 10,
        "32": 14,
        "34": 18,
        "36": 16,
        "38": 12
      }
    },
    url: "010124m001058"
  },
  {
    id: 30,
    productId: "001059",
    datePosted: "01724",
    name: "Men's Formal Blazer",
    category: "man",
    mainCategory: "men",
    subcategory: "formal",
    price: 9990,
    image: "https://picsum.photos/500/750?random=61",
    images: [
      "https://picsum.photos/500/750?random=61",
      "https://picsum.photos/500/750?random=62"
    ],
    description: "Classic formal blazer for men with premium finish.",
    isNew: true,
    sizes: ["38", "40", "42", "44"],
    colors: ["Navy", "Black", "Grey"],
    fabric: "Wool Blend",
    material: "80% Wool, 20% Polyester",
    care: "Dry clean only",
    stock: {
      "Navy": {
        "38": 5,
        "40": 8,
        "42": 10,
        "44": 6
      },
      "Black": {
        "38": 4,
        "40": 6,
        "42": 8,
        "44": 5
      },
      "Grey": {
        "38": 6,
        "40": 9,
        "42": 11,
        "44": 7
      }
    },
    url: "010124m001059"
  },
  {
    id: 31,
    productId: "001060",
    datePosted: "01724",
    name: "Luxury Evening Gown",
    category: "ready-to-wear",
    mainCategory: "women",
    subcategory: "formal",
    price: 12990,
    image: "https://picsum.photos/500/750?random=63",
    images: [
      "https://picsum.photos/500/750?random=63",
      "https://picsum.photos/500/750?random=64"
    ],
    description: "Stunning evening gown with crystal embellishments.",
    isNew: true,
    sizes: ["XS", "S", "M", "L"],
    colors: ["Black", "Navy", "Wine"],
    fabric: "Premium Silk",
    material: "Pure Silk",
    care: "Dry clean only",
    stock: {
      "Black": {
        "XS": 3,
        "S": 5,
        "M": 6,
        "L": 4
      },
      "Navy": {
        "XS": 2,
        "S": 4,
        "M": 5,
        "L": 3
      },
      "Wine": {
        "XS": 4,
        "S": 6,
        "M": 7,
        "L": 5
      }
    },
    url: "010124w001060"
  },
  {
    id: 32,
    productId: "001061",
    datePosted: "01724",
    name: "Casual Summer Dress",
    category: "west",
    mainCategory: "women",
    subcategory: "dresses",
    price: 4990,
    image: "https://picsum.photos/500/750?random=65",
    images: [
      "https://picsum.photos/500/750?random=65",
      "https://picsum.photos/500/750?random=66"
    ],
    description: "Light and breezy summer dress with floral print.",
    isNew: true,
    sizes: ["XS", "S", "M", "L", "XL"],
    colors: ["Floral Print", "Blue Print"],
    fabric: "Cotton",
    material: "100% Cotton",
    care: "Machine wash cold",
    stock: {
      "Floral Print": {
        "XS": 10,
        "S": 15,
        "M": 18,
        "L": 12,
        "XL": 8
      },
      "Blue Print": {
        "XS": 8,
        "S": 12,
        "M": 15,
        "L": 10,
        "XL": 6
      }
    },
    url: "010124w001061"
  },
  {
    id: 33,
    productId: "001062",
    datePosted: "01724",
    name: "Men's Summer Shorts",
    category: "man",
    mainCategory: "men",
    subcategory: "shorts",
    price: 2990,
    image: "https://picsum.photos/500/750?random=67",
    images: [
      "https://picsum.photos/500/750?random=67",
      "https://picsum.photos/500/750?random=68"
    ],
    description: "Comfortable cotton shorts for casual summer wear.",
    isNew: true,
    sizes: ["30", "32", "34", "36", "38"],
    colors: ["Khaki", "Navy", "Grey"],
    fabric: "Cotton",
    material: "100% Cotton",
    care: "Machine wash cold",
    stock: {
      "Khaki": {
        "30": 12,
        "32": 16,
        "34": 20,
        "36": 18,
        "38": 14
      },
      "Navy": {
        "30": 10,
        "32": 14,
        "34": 18,
        "36": 16,
        "38": 12
      },
      "Grey": {
        "30": 8,
        "32": 12,
        "34": 16,
        "36": 14,
        "38": 10
      }
    },
    url: "010124m001062"
  },
  {
    id: 34,
    productId: "001063",
    datePosted: "01724",
    name: "Men's Polo Shirt",
    category: "man",
    mainCategory: "men",
    subcategory: "casual",
    price: 3490,
    image: "https://picsum.photos/500/750?random=69",
    images: [
      "https://picsum.photos/500/750?random=69",
      "https://picsum.photos/500/750?random=70"
    ],
    description: "Classic polo shirt with comfortable fit.",
    isNew: true,
    sizes: ["S", "M", "L", "XL", "XXL"],
    colors: ["White", "Navy", "Red"],
    fabric: "Cotton Pique",
    material: "100% Cotton",
    care: "Machine wash cold",
    stock: {
      "White": {
        "S": 15,
        "M": 20,
        "L": 18,
        "XL": 14,
        "XXL": 10
      },
      "Navy": {
        "S": 12,
        "M": 16,
        "L": 15,
        "XL": 12,
        "XXL": 8
      },
      "Red": {
        "S": 10,
        "M": 14,
        "L": 12,
        "XL": 10,
        "XXL": 6
      }
    },
    url: "010124m001063"
  },
  {
    id: 35,
    productId: "001064",
    datePosted: "01724",
    name: "Men's Formal Trousers",
    category: "man",
    mainCategory: "men",
    subcategory: "formal",
    price: 4990,
    image: "https://picsum.photos/500/750?random=71",
    images: [
      "https://picsum.photos/500/750?random=71",
      "https://picsum.photos/500/750?random=72"
    ],
    description: "Classic formal trousers with perfect fit.",
    isNew: true,
    sizes: ["30", "32", "34", "36", "38"],
    colors: ["Black", "Navy", "Grey"],
    fabric: "Wool Blend",
    material: "80% Wool, 20% Polyester",
    care: "Dry clean only",
    stock: {
      "Black": {
        "30": 6,
        "32": 10,
        "34": 12,
        "36": 10,
        "38": 8
      },
      "Navy": {
        "30": 5,
        "32": 8,
        "34": 10,
        "36": 8,
        "38": 6
      },
      "Grey": {
        "30": 7,
        "32": 11,
        "34": 13,
        "36": 11,
        "38": 9
      }
    },
    url: "010124m001064"
  },
  {
    id: 36,
    productId: "001065",
    datePosted: "01724",
    name: "Women's Formal Pants",
    category: "west",
    mainCategory: "women",
    subcategory: "bottoms",
    price: 4490,
    image: "https://picsum.photos/500/750?random=73",
    images: [
      "https://picsum.photos/500/750?random=73",
      "https://picsum.photos/500/750?random=74"
    ],
    description: "Elegant formal pants with modern cut.",
    isNew: true,
    sizes: ["XS", "S", "M", "L", "XL"],
    colors: ["Black", "Navy", "Grey"],
    fabric: "Polyester Blend",
    material: "65% Polyester, 35% Viscose",
    care: "Dry clean recommended",
    stock: {
      "Black": {
        "XS": 8,
        "S": 12,
        "M": 15,
        "L": 10,
        "XL": 6
      },
      "Navy": {
        "XS": 6,
        "S": 10,
        "M": 13,
        "L": 8,
        "XL": 5
      },
      "Grey": {
        "XS": 10,
        "S": 14,
        "M": 17,
        "L": 12,
        "XL": 8
      }
    },
    url: "010124w001065"
  },
  {
    id: 37,
    productId: "001066",
    datePosted: "01724",
    name: "Casual Denim Skirt",
    category: "west",
    mainCategory: "women",
    subcategory: "bottoms",
    price: 3990,
    image: "https://picsum.photos/500/750?random=75",
    images: [
      "https://picsum.photos/500/750?random=75",
      "https://picsum.photos/500/750?random=76"
    ],
    description: "Stylish denim skirt with perfect length.",
    isNew: true,
    sizes: ["XS", "S", "M", "L"],
    colors: ["Blue", "Black"],
    fabric: "Denim",
    material: "100% Cotton",
    care: "Machine wash cold",
    stock: {
      "Blue": {
        "XS": 12,
        "S": 16,
        "M": 20,
        "L": 14
      },
      "Black": {
        "XS": 10,
        "S": 14,
        "M": 18,
        "L": 12
      }
    },
    url: "010124w001066"
  },
  {
    id: 38,
    productId: "001067",
    datePosted: "01724",
    name: "Summer Crop Top",
    category: "west",
    mainCategory: "women",
    subcategory: "tops",
    price: 2490,
    image: "https://picsum.photos/500/750?random=77",
    images: [
      "https://picsum.photos/500/750?random=77",
      "https://picsum.photos/500/750?random=78"
    ],
    description: "Trendy crop top perfect for summer.",
    isNew: true,
    sizes: ["XS", "S", "M", "L"],
    colors: ["White", "Black", "Pink"],
    fabric: "Cotton Jersey",
    material: "95% Cotton, 5% Elastane",
    care: "Machine wash cold",
    stock: {
      "White": {
        "XS": 15,
        "S": 20,
        "M": 22,
        "L": 18
      },
      "Black": {
        "XS": 12,
        "S": 16,
        "M": 18,
        "L": 14
      },
      "Pink": {
        "XS": 10,
        "S": 14,
        "M": 16,
        "L": 12
      }
    },
    url: "010124w001067"
  },
  {
    id: 39,
    productId: "001068",
    datePosted: "01724",
    name: "Formal Blazer",
    category: "west",
    mainCategory: "women",
    subcategory: "outerwear",
    price: 7990,
    image: "https://picsum.photos/500/750?random=79",
    images: [
      "https://picsum.photos/500/750?random=79",
      "https://picsum.photos/500/750?random=80"
    ],
    description: "Classic formal blazer with modern cut.",
    isNew: true,
    sizes: ["XS", "S", "M", "L", "XL"],
    colors: ["Black", "Navy", "Beige"],
    fabric: "Polyester Blend",
    material: "65% Polyester, 35% Viscose",
    care: "Dry clean only",
    stock: {
      "Black": {
        "XS": 6,
        "S": 10,
        "M": 12,
        "L": 8,
        "XL": 5
      },
      "Navy": {
        "XS": 5,
        "S": 8,
        "M": 10,
        "L": 6,
        "XL": 4
      },
      "Beige": {
        "XS": 7,
        "S": 11,
        "M": 13,
        "L": 9,
        "XL": 6
      }
    },
    url: "010124w001068"
  },
  {
    id: 40,
    productId: "001069",
    datePosted: "01724",
    name: "Casual Cardigan",
    category: "west",
    mainCategory: "women",
    subcategory: "outerwear",
    price: 4990,
    image: "https://picsum.photos/500/750?random=81",
    images: [
      "https://picsum.photos/500/750?random=81",
      "https://picsum.photos/500/750?random=82"
    ],
    description: "Comfortable cardigan for casual wear.",
    isNew: true,
    sizes: ["S", "M", "L", "XL"],
    colors: ["Grey", "Navy", "Beige"],
    fabric: "Knit",
    material: "60% Cotton, 40% Acrylic",
    care: "Hand wash cold",
    stock: {
      "Grey": {
        "S": 12,
        "M": 16,
        "L": 14,
        "XL": 10
      },
      "Navy": {
        "S": 10,
        "M": 14,
        "L": 12,
        "XL": 8
      },
      "Beige": {
        "S": 8,
        "M": 12,
        "L": 10,
        "XL": 6
      }
    },
    url: "010124w001069"
  },
  {
    id: 41,
    productId: "001070",
    datePosted: "01724",
    name: "Leather Wallet",
    category: "accessories",
    mainCategory: "women",
    subcategory: "wallets",
    price: 3990,
    image: "https://picsum.photos/500/500?random=83",
    images: [
      "https://picsum.photos/500/500?random=83",
      "https://picsum.photos/500/500?random=84"
    ],
    description: "Premium leather wallet with multiple compartments.",
    isNew: true,
    colors: ["Black", "Brown", "Red"],
    material: "Genuine Leather",
    care: "Clean with leather cleaner",
    stock: {
      "Black": 18,
      "Brown": 15,
      "Red": 12
    },
    url: "010124w001070"
  },
  {
    id: 42,
    productId: "001071",
    datePosted: "01724",
    name: "Designer Belt",
    category: "accessories",
    mainCategory: "women",
    subcategory: "belts",
    price: 2990,
    image: "https://picsum.photos/500/500?random=85",
    images: [
      "https://picsum.photos/500/500?random=85",
      "https://picsum.photos/500/500?random=86"
    ],
    description: "Stylish belt with designer buckle.",
    isNew: true,
    sizes: ["S", "M", "L"],
    colors: ["Black", "Brown", "Gold"],
    material: "Leather & Metal",
    care: "Wipe clean",
    stock: {
      "Black": {
        "S": 10,
        "M": 15,
        "L": 12
      },
      "Brown": {
        "S": 8,
        "M": 12,
        "L": 10
      },
      "Gold": {
        "S": 6,
        "M": 10,
        "L": 8
      }
    },
    url: "010124w001071"
  },
  {
    id: 43,
    productId: "001072",
    datePosted: "01724",
    name: "Pearl Hair Clips Set",
    category: "accessories",
    mainCategory: "women",
    subcategory: "hair-accessories",
    price: 1990,
    image: "https://picsum.photos/500/500?random=87",
    images: [
      "https://picsum.photos/500/500?random=87",
      "https://picsum.photos/500/500?random=88"
    ],
    description: "Set of elegant pearl hair clips.",
    isNew: true,
    colors: ["Pearl White", "Gold"],
    material: "Metal & Pearl",
    care: "Store in jewelry box",
    stock: {
      "Pearl White": 25,
      "Gold": 20
    },
    url: "010124w001072"
  },
  {
    id: 44,
    productId: "001073",
    datePosted: "01724",
    name: "Crystal Bracelet",
    category: "accessories",
    mainCategory: "women",
    subcategory: "jewelry",
    price: 2490,
    image: "https://picsum.photos/500/500?random=89",
    images: [
      "https://picsum.photos/500/500?random=89",
      "https://picsum.photos/500/500?random=90"
    ],
    description: "Elegant crystal bracelet for special occasions.",
    isNew: true,
    colors: ["Silver", "Gold", "Rose Gold"],
    material: "Metal & Crystal",
    care: "Store in jewelry box",
    stock: {
      "Silver": 16,
      "Gold": 14,
      "Rose Gold": 12
    },
    url: "010124w001073"
  },
  {
    id: 45,
    productId: "001074",
    datePosted: "01724",
    name: "Men's Leather Belt",
    category: "accessories",
    mainCategory: "men",
    subcategory: "belts",
    price: 3490,
    image: "https://picsum.photos/500/500?random=91",
    images: [
      "https://picsum.photos/500/500?random=91",
      "https://picsum.photos/500/500?random=92"
    ],
    description: "Classic leather belt for men.",
    isNew: true,
    sizes: ["32", "34", "36", "38", "40"],
    colors: ["Black", "Brown"],
    material: "Genuine Leather",
    care: "Clean with leather cleaner",
    stock: {
      "Black": {
        "32": 8,
        "34": 12,
        "36": 15,
        "38": 10,
        "40": 6
      },
      "Brown": {
        "32": 6,
        "34": 10,
        "36": 12,
        "38": 8,
        "40": 5
      }
    },
    url: "010124m001074"
  },
  {
    id: 46,
    productId: "001075",
    datePosted: "01724",
    name: "Men's Wallet",
    category: "accessories",
    mainCategory: "men",
    subcategory: "wallets",
    price: 2990,
    image: "https://picsum.photos/500/500?random=93",
    images: [
      "https://picsum.photos/500/500?random=93",
      "https://picsum.photos/500/500?random=94"
    ],
    description: "Classic leather wallet for men.",
    isNew: true,
    colors: ["Black", "Brown"],
    material: "Genuine Leather",
    care: "Clean with leather cleaner",
    stock: {
      "Black": 20,
      "Brown": 16
    },
    url: "010124m001075"
  },
  {
    id: 47,
    productId: "001076",
    datePosted: "01724",
    name: "Men's Watch",
    category: "accessories",
    mainCategory: "men",
    subcategory: "watches",
    price: 8990,
    image: "https://picsum.photos/500/500?random=95",
    images: [
      "https://picsum.photos/500/500?random=95",
      "https://picsum.photos/500/500?random=96"
    ],
    description: "Classic analog watch for men.",
    isNew: true,
    colors: ["Silver", "Gold", "Black"],
    material: "Stainless Steel",
    care: "Clean with soft cloth",
    stock: {
      "Silver": 12,
      "Gold": 8,
      "Black": 15
    },
    url: "010124m001076"
  },
  {
    id: 48,
    productId: "001077",
    datePosted: "01724",
    name: "Men's Tie Set",
    category: "accessories",
    mainCategory: "men",
    subcategory: "ties",
    price: 2990,
    image: "https://picsum.photos/500/500?random=97",
    images: [
      "https://picsum.photos/500/500?random=97",
      "https://picsum.photos/500/500?random=98"
    ],
    description: "Classic tie set with matching pocket square.",
    isNew: true,
    colors: ["Navy", "Black", "Burgundy"],
    material: "Silk Blend",
    care: "Dry clean only",
    stock: {
      "Navy": 18,
      "Black": 16,
      "Burgundy": 14
    },
    url: "010124m001077"
  },
  {
    id: 49,
    productId: "001078",
    datePosted: "01724",
    name: "Men's Cufflinks",
    category: "accessories",
    mainCategory: "men",
    subcategory: "jewelry",
    price: 3990,
    image: "https://picsum.photos/500/500?random=99",
    images: [
      "https://picsum.photos/500/500?random=99",
      "https://picsum.photos/500/500?random=100"
    ],
    description: "Elegant cufflinks for formal occasions.",
    isNew: true,
    colors: ["Silver", "Gold"],
    material: "Metal",
    care: "Store in jewelry box",
    stock: {
      "Silver": 15,
      "Gold": 12
    },
    url: "010124m001078"
  },
  {
    id: 50,
    productId: "001079",
    datePosted: "01724",
    name: "Men's Sunglasses",
    category: "accessories",
    mainCategory: "men",
    subcategory: "eyewear",
    price: 4990,
    image: "https://picsum.photos/500/500?random=101",
    images: [
      "https://picsum.photos/500/500?random=101",
      "https://picsum.photos/500/500?random=102"
    ],
    description: "Classic aviator sunglasses for men.",
    isNew: true,
    colors: ["Gold/Green", "Silver/Grey", "Black/Black"],
    material: "Metal & Glass",
    care: "Clean with microfiber cloth",
    stock: {
      "Gold/Green": 14,
      "Silver/Grey": 12,
      "Black/Black": 16
    },
    url: "010124m001079"
  }
];

// Categories configuration
export const categories = {
  "new-in": {
    name: "New In",
    subcategories: {
      "unstitched": "Unstitched",
      "ready-to-wear": "Ready to Wear",
      "man": "Man"
    }
  },
  "woman": {
    name: "Woman",
    subcategories: {
      "ready-to-wear": "Ready to Wear",
      "unstitched": "Unstitched",
      "west": "WEST",
      "sleepwear": "Sleepwear",
      "modest-wear": "Modest Wear"
    }
  },
  "man": {
    name: "Man",
    subcategories: {
      "unstitched": "Men's Unstitched",
      "stitched": "Men's Stitched",
      "kurtas": "Kurtas",
      "waistcoats": "Waistcoats"
    }
  },
  "kids": {
    name: "Kids",
    subcategories: {
      "dresses": "Dresses",
      "traditional": "Traditional",
      "casual": "Casual"
    }
  },
  "fragrances": {
    name: "Fragrances",
    subcategories: {
      "women": "For Her",
      "men": "For Him",
      "unisex": "Unisex"
    }
  },
  "accessories": {
    name: "Accessories",
    subcategories: {
      "bags": "Bags",
      "shoes": "Shoes",
      "jewelry": "Jewelry"
    }
  },
  "special": {
    name: "Special",
    subcategories: {
      "limited": "Limited Edition",
      "designer": "Designer Collection",
      "bridal": "Bridal Wear"
    }
  }
};

// Featured collections for homepage
export const featuredCollections = [
  {
    id: 1,
    name: "Ready to Wear Summer '25",
    description: "New Arrivals",
    image: "https://images.unsplash.com/photo-1594633312681-425c7b97ccd1?w=800&h=600&fit=crop",
    link: "/category/ready-to-wear"
  },
  {
    id: 2,
    name: "Unstitched Summer '25",
    description: "New Arrivals",
    image: "https://images.unsplash.com/photo-1583292746440-3c78055b86d1?w=800&h=600&fit=crop",
    link: "/category/unstitched"
  },
  {
    id: 3,
    name: "Day to Day Summer",
    description: "Unstitched",
    image: "https://images.unsplash.com/photo-1551698618-1dfe5d97d256?w=800&h=600&fit=crop",
    link: "/category/unstitched/day-to-day"
  },
  {
    id: 4,
    name: "Men's Summer '25",
    description: "Unstitched & Stitched",
    image: "https://images.unsplash.com/photo-1605518216938-7c31b7b14ad0?w=800&h=600&fit=crop",
    link: "/category/man"
  }
];

// Helper functions for product management
export const getProductsByCategory = (category, subcategory = null) => {
  // Special handling for "new-in" category - return all products with isNew: true
  if (category === 'new-in') {
    let newProducts = products.filter(product => product.isNew === true);
    
    // If subcategory is specified, further filter by subcategory
    if (subcategory) {
      newProducts = newProducts.filter(product => product.subcategory === subcategory);
    }
    
    // Sort by newest first for new-in category
    newProducts.sort((a, b) => new Date(b.datePosted || b.dateAdded || '01724') - new Date(a.datePosted || a.dateAdded || '01724'));
    
    return newProducts;
  }
  
  // Regular category filtering
  return products.filter(product => {
    if (subcategory) {
      return product.category === category && product.subcategory === subcategory;
    }
    return product.category === category;
  });
};

export const getFeaturedProducts = () => {
  return products.filter(product => product.isNew || product.isOnSale);
};

export const getSaleProducts = () => {
  return products.filter(product => product.isOnSale);
};

export const getNewArrivals = () => {
  return products.filter(product => product.isNew);
};

export const getProductById = (id) => {
  return products.find(product => product.id === id);
};

export const getProductByUrl = (url) => {
  return products.find(product => product.url === url);
};

// Get category code from main category
const getCategoryCode = (mainCategory) => {
  const categoryCodes = {
    'women': 'w',
    'men': 'm', 
    'kids': 'k',
    'accessories': 'a',
    'fragrances': 'f',
    'special': 's'
  };
  return categoryCodes[mainCategory] || 'w';
};

// Get main category from category code
const getMainCategoryFromCode = (categoryCode) => {
  const categoryMap = {
    'w': 'women',
    'm': 'men',
    'k': 'kids',
    'a': 'accessories',
    'f': 'fragrances',
    's': 'special'
  };
  return categoryMap[categoryCode] || 'women';
};

export const parseProductUrl = (url) => {
  if (!url || url.length < 12) return null;
  
  const datePosted = url.substring(0, 6);  // DDMMYY format (6 digits)
  const categoryCode = url.substring(6, 7);  // Single letter category code
  const productId = url.substring(7);  // Remaining digits
  
  return {
    datePosted,
    mainCategory: getMainCategoryFromCode(categoryCode),
    productId
  };
};

export const generateProductUrl = (product) => {
  const categoryCode = getCategoryCode(product.mainCategory);
  return `${product.datePosted}${categoryCode}${product.productId}`;
};

export const getAllProductUrls = () => {
  return products.map(product => product.url);
};

// Stock Management Functions
export const getProductStock = (productId, color = null, size = null) => {
  const product = products.find(p => p.id === productId);
  if (!product || !product.stock) return 0;
  
  // For unstitched products (no sizes)
  if (!product.sizes && color) {
    return product.stock[color] || 0;
  }
  
  // For regular products (with sizes and colors)
  if (color && size && product.stock[color]) {
    return product.stock[color][size] || 0;
  }
  
  return 0;
};

export const updateProductStock = (productId, color, size = null, quantity) => {
  const productIndex = products.findIndex(p => p.id === productId);
  if (productIndex === -1) return false;
  
  const product = products[productIndex];
  
  // Initialize stock object if it doesn't exist
  if (!product.stock) {
    product.stock = {};
  }
  
  // For unstitched products (no sizes)
  if (!product.sizes) {
    product.stock[color] = Math.max(0, quantity);
  } else {
    // For regular products (with sizes and colors)
    if (!product.stock[color]) {
      product.stock[color] = {};
    }
    product.stock[color][size] = Math.max(0, quantity);
  }
  
  // Update the products array
  products[productIndex] = product;
  
  // Check if product is now out of stock and trigger notification
  checkOutOfStockNotification(product);
  
  return true;
};

export const decreaseProductStock = (productId, color, size = null, quantity = 1) => {
  const currentStock = getProductStock(productId, color, size);
  const newStock = Math.max(0, currentStock - quantity);
  return updateProductStock(productId, color, size, newStock);
};

export const increaseProductStock = (productId, color, size = null, quantity = 1) => {
  const currentStock = getProductStock(productId, color, size);
  return updateProductStock(productId, color, size, currentStock + quantity);
};

export const isProductInStock = (productId, color = null, size = null) => {
  return getProductStock(productId, color, size) > 0;
};

export const getAvailableColors = (productId) => {
  const product = products.find(p => p.id === productId);
  if (!product || !product.stock) return product?.colors || [];
  
  // For unstitched products
  if (!product.sizes) {
    return Object.keys(product.stock).filter(color => product.stock[color] > 0);
  }
  
  // For regular products
  return Object.keys(product.stock).filter(color => 
    Object.values(product.stock[color]).some(stock => stock > 0)
  );
};

export const getAvailableSizes = (productId, color) => {
  const product = products.find(p => p.id === productId);
  if (!product || !product.sizes || !product.stock || !product.stock[color]) {
    return product?.sizes || [];
  }
  
  return Object.keys(product.stock[color]).filter(size => 
    product.stock[color][size] > 0
  );
};

export const getOutOfStockProducts = () => {
  return products.filter(product => {
    if (!product.stock) return false;
    
    // For unstitched products
    if (!product.sizes) {
      return Object.values(product.stock).every(stock => stock === 0);
    }
    
    // For regular products
    return Object.values(product.stock).every(colorStock => 
      Object.values(colorStock).every(stock => stock === 0)
    );
  });
};

export const getLowStockProducts = (threshold = 5) => {
  return products.filter(product => {
    if (!product.stock) return false;
    
    // For unstitched products
    if (!product.sizes) {
      return Object.values(product.stock).some(stock => stock > 0 && stock <= threshold);
    }
    
    // For regular products
    return Object.values(product.stock).some(colorStock => 
      Object.values(colorStock).some(stock => stock > 0 && stock <= threshold)
    );
  });
};

// Notification system for out of stock products
let outOfStockNotifications = [];

export const checkOutOfStockNotification = (product) => {
  const isOutOfStock = getOutOfStockProducts().some(p => p.id === product.id);
  
  if (isOutOfStock) {
    const notification = {
      id: Date.now(),
      type: 'out-of-stock',
      product: product,
      message: `${product.name} is now out of stock`,
      timestamp: new Date(),
      read: false
    };
    
    outOfStockNotifications.push(notification);
    
    // Trigger notification event
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent('outOfStockNotification', {
        detail: notification
      }));
    }
  }
};

export const getOutOfStockNotifications = () => {
  return outOfStockNotifications;
};

export const markNotificationAsRead = (notificationId) => {
  const notification = outOfStockNotifications.find(n => n.id === notificationId);
  if (notification) {
    notification.read = true;
  }
};

export const clearNotifications = () => {
  outOfStockNotifications = [];
}; 